// @flow

import React from 'react';
import bemify from 'bemify-js';
import { toClass } from 'recompose';

import BooleanInput from 'app/common/components/BooleanInput';
import purifyWithDeepCheck from 'app/perf-utils/components/purifyWithDeepCheck';
import 'app/common/components/SelectBox.scss';

const bem = bemify('select-box');

type SelectBoxField = {
  isAllSelected: boolean,
  hasSelections: boolean,
  inputType: 'checkbox',
};

type SelectBoxProps = {
  field: SelectBoxField,
  isDisabled: boolean,
};

const SelectBox = (props: SelectBoxProps) => {
  const { field } = props;

  return (
    <div className="pretty-text-wrapper">
      <div
        className={bem(
          'fm-pretty-select-input',
          'fm-pretty-text-input',
          'pretty-text-box'
        )}
      >
        <BooleanInput
          checked={field.isAllSelected}
          className={bem('__boolean-input')}
          disabled={props.isDisabled}
          hasExternalLabel={true}
          indeterminate={!field.isAllSelected && field.hasSelections}
          name="select"
          type="checkbox"
          value=""
        />
      </div>
    </div>
  );
};

// Hack because Formatic will pass a ref to this component.
export default purifyWithDeepCheck(toClass(SelectBox));
